import React from 'react';

export default function TermsAndConditions() {
  return (
    <div className="bg-white min-h-screen flex flex-col py-10 px-2">
      <div className="max-w-6xl mx-auto bg-white rounded-xl shadow-xl border border-gray-200 p-8">
        <h1 className="text-6xl font-bold text-purple-600 mb-6 text-center">Terms &amp; Conditions</h1>
        <p className="mb-6 text-lg text-center text-gray-700">
          By accessing or using Million2Trillion, you agree to comply with and be bound by the following terms and conditions.
        </p>

        <div className="space-y-8">
          <div>
            <h3 className="text-xl text-purple-600 font-semibold mb-2">1. Acceptance of Terms</h3>
            <p className="text-gray-700">
              These Terms apply to all users of the platform. If you do not agree, you may not access or use the services.
            </p>
          </div>

          <div>
            <h3 className="text-xl text-purple-600 font-semibold mb-2">2. User Responsibilities</h3>
            <ul className="list-disc list-inside space-y-1 pl-4 text-gray-700">
              <li>Do not misuse the platform for unlawful activities.</li>
              <li>You are responsible for any content you submit or share.</li>
              <li>Respect all users and maintain professional conduct.</li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl text-purple-600 font-semibold mb-2">3. Intellectual Property</h3>
            <p className="text-gray-700">
              All content and features on Million2Trillion belong to M2T Global Technologies unless stated otherwise.
              Unauthorized use, reproduction, or distribution is strictly prohibited.
            </p>
          </div>

          <div>
            <h3 className="text-xl text-purple-600 font-semibold mb-2">4. Service Modifications</h3>
            <p className="text-gray-700">
              We reserve the right to modify or discontinue any part of the platform at any time without prior notice.
            </p>
          </div>

          <div>
            <h3 className="text-xl text-purple-600 font-semibold mb-2">5. Disclaimer of Warranties</h3>
            <p className="text-gray-700">
              Million2Trillion is provided &quot;as is&quot; without warranties of any kind. Use it at your own risk.
            </p>
          </div>

          <div>
            <h3 className="text-xl text-purple-600 font-semibold mb-2">6. Limitation of Liability</h3>
            <p className="text-gray-700">
              M2T Global Technologies is not liable for any damages or losses resulting from your use of the platform.
            </p>
          </div>

          <div>
            <h3 className="text-xl text-purple-600 font-semibold mb-2">7. Changes to Terms</h3>
            <p className="text-gray-700">
              We may update these terms from time to time. Continued use of the platform means you accept the new terms.
            </p>
          </div>

          <div>
            <h3 className="text-xl text-purple-600 font-semibold mb-2">8. Governing Law</h3>
            <p className="text-gray-700">
              These Terms are governed by and interpreted in accordance with the laws of India.
            </p>
          </div>

          <p className="mt-12 text-sm text-center text-gray-500 italic">
            Last updated: June 2025
          </p>
        </div>
      </div>
    </div>
  );
}
